(() => {
  const portalOrigin = 'https://my.diliclothing.com';

  function portalUrlFor(href) {
    try {
      const u = new URL(href, window.location.origin);
      const host = u.hostname.toLowerCase();
      const path = u.pathname.toLowerCase();
      const isNativeAccountHost = host === 'account.diliclothing.com';
      const isStoreAccountPath = (host === 'diliclothing.com' || host === 'www.diliclothing.com' || host.endsWith('.myshopify.com')) && path.startsWith('/account');
      if (!isNativeAccountHost && !isStoreAccountPath) return null;

      if (path.includes('/orders')) return portalOrigin + '/orders';
      if (path.includes('/addresses')) return portalOrigin + '/addresses';
      if (path.includes('/profile')) return portalOrigin + '/profile';
      if (path.includes('/returns')) return portalOrigin + '/returns';
      return portalOrigin + '/';
    } catch (_) {
      return null;
    }
  }

  function rewrite(root = document) {
    root.querySelectorAll?.('a[href]').forEach((a) => {
      const mapped = portalUrlFor(a.href);
      if (mapped) {
        a.href = mapped;
        a.dataset.diliAccountLink = 'true';
      }
    });
  }

  rewrite();
  document.addEventListener('DOMContentLoaded', () => rewrite());
  document.addEventListener('click', (event) => {
    const a = event.target.closest?.('a[href]');
    if (!a) return;
    const mapped = portalUrlFor(a.href);
    if (!mapped) return;
    event.preventDefault();
    window.location.assign(mapped);
  }, true);

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1) rewrite(node);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
